// src/utils/coreassure/weldAssureApi.js
//
// CoreAssure WeldAssure (D-048 §4.2) — Day 3-5 MVP frontend API client.
// Mirrors the convention of readinessApi.js, calibrationApi.js, etc.
// Per CR-2026-CA-NAMESPACE §2.1: file lives under src/utils/coreassure/.
// Per CR-2026-CA-NAMESPACE §2.5: audit_log event_type prefix is `CA-WELD-`.

import ApiCall from "../apicall";

// ── Validation check (read-only, on-demand POST) ────────────────────────────
export const weldAssureApi = {
  /**
   * Run WeldAssure validation for a (weldTask, welder, wps) combo.
   * Returns axios response. data.data is the result envelope per
   * CR-2026-CA-WELDASSURE-MVP §4 API contract.
   *
   * @param {Object} params
   * @param {number|string} params.weldTaskId
   * @param {number|string} params.welderId
   * @param {number|string} [params.wpsId]  optional; falls back to weld-task's assigned WPS
   */
  check: ({ weldTaskId, welderId, wpsId }) =>
    ApiCall.post("/coreassure/weld-assure/check", {
      weldTaskId,
      welderId,
      wpsId: wpsId || null,
    }),
};

// ── Result enums (kept in sync with backend) ────────────────────────────────
export const WELD_RESULT = {
  SUCCESS: "SUCCESS",
  WARNING: "WARNING",
};

export const WELD_RESULT_PALETTE = {
  SUCCESS: { bg: "#e8f5ec", fg: "#127038", border: "#127038", icon: "PASS" },
  WARNING: { bg: "#fff5e0", fg: "#a06010", border: "#a06010", icon: "WARN" },
};

export const CATEGORY_LABEL = {
  wps:         "WPS approval (ASME IX)",
  welder_qual: "Welder qualification (D1.1 §4)",
  thickness:   "Thickness range",
  material:    "Material compatibility",
  expiration:  "Qualification expiration timing",
};

// Block-reason enum — aligns with backend block_reason values
export const BLOCK_REASON_LABEL = {
  WPS_NOT_APPROVED:     "WPS not approved",
  WELDER_QUAL_MISSING:  "Welder has no current qualification",
  WELDER_QUAL_EXPIRED:  "Welder qualification expired",
  THICKNESS_OUT_OF_RANGE: "Thickness outside WPS range (Phase 2 — currently advisory)",
  MATERIAL_INCOMPATIBLE:  "Material grade not compatible with WPS (Phase 2 — currently advisory)",
  WPS_NOT_SPECIFIED:    "No WPS specified for this weld-task",
};
